module.exports = __webpack_public_path__ + "assets/fold-a85eb4.svg";